import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import * as React from "react";
import Select from "react-select";
import styled from "../../styled-components";
import { VersionSwitcherWrapper } from "./styled.elements";
export default function VersionSwitcher(a) {
  var b = React.useMemo(function () {
    return a.apiVersions.map(function (a) {
      return {
        label: a.title,
        value: a.id
      };
    });
  }, [a.apiVersions]),
      c = b.find(function (b) {
    return b.value === a.apiVersionId;
  });
  return /*#__PURE__*/React.createElement(VersionSwitcherWrapper, {
    "data-cy": "reference-docs-version-switcher"
  }, /*#__PURE__*/React.createElement(StyledSelect, Object.assign({
    placeholder: "Select version",
    classNamePrefix: "react-select"
  }, a, {
    options: b,
    value: c,
    onChange: a.onVersionChange
  })));
}
var StyledSelect = styled(Select)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  .react-select {\n    &__menu {\n      margin-top: 0;\n      z-index: 200;\n    }\n    &__option {\n      &--is-selected,\n      &--is-focused,\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n      }\n    }\n    &__control {\n      min-height: 36px;\n      border-radius: ", ";\n      &--is-focused {\n        box-shadow: 0 0 0 1px ", ";\n        border-color: ", ";\n      }\n    }\n    &__indicator {\n      svg {\n        fill: #53565a;\n      }\n    }\n    &__indicator-separator {\n      display: none;\n    }\n  }\n\n  input {\n    caret-color: transparent;\n  }\n"])), function (_ref) {
  var a = _ref.theme;
  return a.sidebar.textColor;
}, function (_ref2) {
  var a = _ref2.theme;
  return a.sidebar.activeBgColor;
}, function (a) {
  return a.theme.shape.borderRadius;
}, function (_ref3) {
  var a = _ref3.theme;
  return a.colors.primary.main;
}, function (_ref4) {
  var a = _ref4.theme;
  return a.colors.primary.main;
});